export default [
  // 碎屏保
  {
    path: '/helpcenter/broken-screen',
    name: 'brokenScreen',
    meta: { type: 'page', title: '碎屏宝', stParams: {} },
    component: () => import(/* webpackChunkName: 'helpcenter' */ 'views/helpcenter/broken-screen')
  },
  // 延保
  {
    path: '/helpcenter/extend-service',
    name: 'extendService',
    meta: { type: 'page', title: '延保', stParams: {} },
    component: () => import(/* webpackChunkName: 'helpcenter' */ 'views/helpcenter/extend-service')
  },
  // 后盖保
  {
    path: '/helpcenter/back-cover',
    name: 'backCover',
    meta: { type: 'page', title: '后盖宝', stParams: {} },
    component: () => import(/* webpackChunkName: 'helpcenter' */ 'views/helpcenter/back-cover')
  },
  // 后盖保
  {
    path: '/helpcenter/vivo-care',
    name: 'vivoCare',
    meta: { type: 'page', title: 'V享无忧', stParams: {} },
    component: () => import(/* webpackChunkName: 'helpcenter' */ 'views/helpcenter/vivo-care')
  },
  // 服务条款
  {
    path: '/helpcenter/vivo-care-pact',
    name: 'vivoCarePact',
    meta: { type: 'page', title: '《vivo 服务条款》', stParams: {} },
    component: () => import(/* webpackChunkName: 'helpcenterpact' */ 'views/helpcenter/vivo-care-pact')
  },
  // 积分说明-目前看，商城没有地方使用，防止分离后缺失，所以添加
  {
    path: '/helpcenter/vcoin_help',
    name: 'vcoinHelp',
    meta: { type: 'page', title: '帮助信息', stParams: {} },
    component: () => import(/* webpackChunkName: 'helpcentervcoin' */ 'views/helpcenter/vcoin-help')
  }
]
